/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import {
	CardElement,
	useElements,
	useStripe
} from "@stripe/react-stripe-js";
import moment from "moment";
import React, {
	useEffect,
	useState
} from "react";
import {
	useLocation,
	useNavigate,
	useParams
} from "react-router-dom";

import {
	ComponentWrapper,
	ErrorWrapper,
	ProductCard,


	MessageListInnerWrapper,

	MessageListItem,
	MessageListItemArrowWrapper,
	MessageListItemContent,
	MessageListItemUnreadWrapper,
	MessageListItemWrapper,

	MessageListInnerFooterWrapper,
	MessageListWrapper,

	MessageWrapper
} from "./Reservation.styled";

import Button from "../../components/Button";
import Card, {
	CardBody,
	CardFooter,
	CardHeader
} from "../../components/Card";
import CountdownTimer from "../../components/CountdownTimer";
import Img from "../../components/Img"; 
import LoaderAnimation from "../../components/LoaderAnimation";

import i18nHelper from "../../helpers/i18n";
import routerHelper from "../../helpers/router";
import storeHelper from "../../helpers/store";
import utilsHelper from "../../helpers/utils";

import useApi from "../../hooks/api";

import i18n from "../../i18n";

// COMPONENT

const Reservation = (props) => {
	const [
		card, 
		setCard
	] = useState(null);
	const [
		error, 
		setError
	] = useState(null);
	const [
		isRenderReady, 
		setIsRenderReady
	] = useState(false);
	const [
		reservation, 
		setReservation
	] = useState({});

	const elements = useElements();
	const {
		fetchApi
	} = useApi();
	const location = useLocation();
	const navigate = useNavigate();
	const params = useParams();
	const stripe = useStripe();

	// Lifecycle

	// Note - Run on bootstrap
	useEffect(
		() => {
			const waitAsync = async () => {
				const response = await fetchApi({
					method: "get",
					params: {
						event_id: params.eventId,
						service: "getEvent"
					}
				});

				if(response.error) {
					parseApiError(
						response.error.code,
						response.error.message
					);

					return;
				}

				const {
					event,
					store
				} = response.payload;

				if(!event.payment) {
					goBack();

					return;
				}

				const offset = moment.parseZone(event.date).utcOffset();
				const date = moment.utc(event.date).utcOffset(offset);

				const newReservation = {
					date: date.format("MMM Do YYYY, h:mm A"),
					event: {
						id: event.id
					},
					payment: {
						fee: event.payment.fee,
						retailPrice: event.payment.retail_price,
						selection: event.payment.size,
						timeout: event.payment.timeout,
						timestamp: event.payment.timestamp
					},
					product: {
						image: event.product.images[0],
						name: event.product.name
					},
					store: {
						address: store.address,
						city: store.city,
						logo: store.logo,
						name: store.name,
						postalCode: store.postal_code
					},
					type: event.type
				};

				setReservation(newReservation);
			};

			waitAsync();
	    }, 
		[]
	);

	// Note - Run when reservation change
	useEffect(
		() => {
			if(utilsHelper.isObjectEmpty(reservation)) {
				return;
			}

			setIsRenderReady(true);
		}, 
		[reservation]
	);

	// Note - Run when elements change
	/*
	useEffect(
		() => {
			if(utilsHelper.isObjectEmpty(elements)) {
				return;
			}

			const ce = elements.getElement(CardElement);
			ce.on(
				"change", 
				cardChangeHandler
			);

			setCard(ce);
		}, 
		[elements]
	);
	*/
	// Events

	/**
	 * cancelReservation - ...
	 * 
	 * @param {object} e ... 
	 */
	const cancelReservation = async (e) => {
		const response = await fetchApi({
			method: "get",
			params: {
				event_id: reservation.event.id,
				service: "eventReservationCancelled"
			}
		});

		console.log(response);
		/*
		if(response.error) {
			let newError;

			switch(response.error.code) {
				//case 141:
				//	newError = "141";
				//break;
				default:
					newError = response.error.code;
				break;
			}

			setError(newError);

			updateInputStates({
				isSubmit: false,
				isValid: false
			});

			return;
		}
		*/
		navigate(-1);
	};

	/**
	 * cancelReservation - ...
	 * 
	 * @param {object} e ... 
	 */
	const cardChangeHandler = (e) => {
		console.log("cardChangeHandler", e);
		/*
		let isValid = false;

		if(e.complete) {
			isValid = true;
		}

		setIsFormValidated(isValid);
		*/
	};

	/**
	 * payReservation - ...
	 * 
	 * @param {object} e ... 
	 */
	const payReservation = async (e) => {
		const stripeResponse = await stripe.createToken(
			elements.getElement(CardElement)
		);

		if(stripeResponse?.token) {
			const savedCardResponse = await fetchApi({
				method: "get",
				params: {
					last4: stripeResponse.token.card.last4,
					service: "savePaymentInfo",
					stripe_token: stripeResponse.token.id,
					type: stripeResponse.token.card.brand
				}
			});

			if(savedCardResponse.error) {
				parseApiError(
					savedCardResponse.error.code,
					savedCardResponse.error.message
				);
	
				return;
			}
		} else if(stripeResponse?.error) {
			console.log(stripeResponse?.error);
			setError(stripeResponse.error.message);

			return;
		}

		const response = await fetchApi({
			method: "get",
			params: {
				event_id: reservation.event.id,
				service: "eventCopPaidConfirmation"
			}
		});

		console.log(response);
		
		if(response.error) {
			parseApiError(
				response.error.code,
				response.error.message
			);

			return;
		}

		//navigate(-1); // to confirmation? as cops???
		navigate({
			pathname: routerHelper.getUrl("cops")
		});
	};

	// Misc

	/**
	 * goBack - ...
	 */
	const goBack = () => {
		navigate(-1);
	};

	/**
	 * parseApiError - ...
	 * 
	 * @param {string} code ... 
	 */
	const parseApiError = (code, message) => {
		switch(code) {
			case 102: // Invalid access token
				reconnect();
			return;
			default:
				//setError(code);
				setError(
					message ||
					code
				);
			return;
		}
	};

	/**
	 * reconnect - ...
	 */
	const reconnect = () => {
		const {
			pathname,
			search
		} = location;
	
		navigate({
			pathname: routerHelper.getUrl("signIn"),
			search: `?redirect=${encodeURIComponent(pathname + search)}`
		});
	};

	//... timedout

	// Render

	/**
	 * render - ... !!! to complete
	 */
	const render = () => {
		let errorContent;
		let eventContent;
		let paymentContent;
		let reservationContent;

		if(error) {
			errorContent = (
				<ErrorWrapper>
					{error}
				</ErrorWrapper>
			);
		}

		if(isRenderReady) {
			eventContent = renderEventCard();
		} else {

		}

		return (
			<ComponentWrapper>
				{errorContent}
				{eventContent}
				{reservationContent}
				{paymentContent}
			</ComponentWrapper>
		);
	};

	/**
	 * renderEventCard - ...
	 */
	const renderEventCard = () => {
		if(utilsHelper.isObjectEmpty(reservation)) {
			return;
		}

		const timeStart = moment.unix(reservation.payment.timestamp).add(reservation.payment.timeout, "seconds").toDate();

		let sizeText;

		switch(reservation.payment.selection.type) {
			case "apparel":
			case "shoe":
				sizeText = i18n.t(
					`general.sizes.${reservation.payment.selection.gender}`,
					{
						size: reservation.payment.selection.size
					}
				);
			break;
			case "time":
				sizeText = reservation.payment.selection.timeSlot;
			break;
		}

		return (
			<Card
				className="reservationCard"
				>
				<CardHeader
					className="reservationCardHeader"
					>
					<p>
						<strong>
							Nice! Your entry was selected!
						</strong>
					</p>
					<p>
						<strong>
							Confirm your reservation within the time allotted to secure your product.
						</strong>
					</p>
					<div
						style={{
							marginTop: "24px"
						}}
						>
						<CountdownTimer
							targetDate={timeStart}
						/>
					</div>
				</CardHeader>
				<CardBody
					className="reservationCardBody"
					>
					<p>
						<small>
							By confirming your reservation, you agree to purchase the product below according to the <a>store rules</a>.
						</small>
					</p>
					<ProductCard>
						<div
							style={{
								padding: "16px",
								gap: "16px",
								display: "flex"
							}}
							>
							<Img
								alt={reservation.product.name}
								className="img"
								src={reservation.product.image}
							/>
							<div
								className="storeContent"
								>
								<strong>
									{reservation.product.name}
								</strong>
								<p>
									<small>
										{sizeText}
									</small>
									<small>
										{`${reservation.store.name}, ${reservation.store.city}`}
									</small>
								</p>
							</div>
						</div>	
						<div
							style={{
								alignItems: "flex-start",
								padding: "16px",
								borderTop: "1px solid #CCC",
								gap: "16px",
								display: "flex",
								justifyContent: "space-between"
							}}
							>
							<div
								style={{
									justifyContent: "flex-start",
									display: "flex",
									flexDirection: "column",
									textAlign: "left"
								}}
							>
							<small>
							<strong>
								Pay to merchant on release day
							</strong>
							</small>
							<small>
								Retail price
							</small>
							</div>
							<div
								style={{
									justifyContent: "flex-start",
									display: "flex",
									flexDirection: "column",
									textAlign: "right"
								}}
							>
							<strong>
								{utilsHelper.formatCurrency(
									reservation.payment.retailPrice
								)}
							</strong>
							<small>
								+ applicable taxes
							</small>
							</div>
						</div>
						<div
							style={{
								padding: "16px",
								borderTop: "1px solid #CCC",
								gap: "16px",
								display: "flex",
								backgroundColor: "#F5F5F5",
								justifyContent: "space-between"
							}}
							>
								<div
								style={{
									justifyContent: "flex-start",
									display: "flex",
									flexDirection: "column",
									textAlign: "left"
								}}
							>
							<small>
							<strong>
								Pay today
							</strong>
							</small>
							<small>
								Reservation fee
							</small>
							</div>
							<div>
							<strong>
								{utilsHelper.formatCurrency(
									reservation.payment.fee
								)}
							</strong>
							</div>
						</div>
					</ProductCard>
						<p>
						<small>
							Your card will not be charged for the product today. Only the reservation fee will be charged today. You will purchase the product from the merchant on release day.
						</small>
					</p>
					<div
						style={{
							marginTop: "24px",
							boxSizing: "border-box",
							width: "100%",
							padding: "16px",
							border: "1px solid #DDD",
							borderRadius: "6px"
						}}
						>
						<CardElement
							id="card-element"
							onBlur={cardChangeHandler}
							onChange={cardChangeHandler}
							onFocus={cardChangeHandler}
						/>
					</div>
					
				</CardBody>
				<CardFooter
					className="reservationCardFooter"
					>
					<Button
						className="button"
						label="Forget it"
						onClick={cancelReservation}
					/>
					<Button
						className="button"
						label={i18n.t(
							"actions.payAmount",
							{
								amount: utilsHelper.formatCurrency(
									reservation.payment.fee
								)
							}
						)}
						onClick={payReservation}
						paletteColor="dark"
					/>
				</CardFooter>
			</Card>
		);
	};

	return render();
};

// EXPORT

export default Reservation;
